import { Button, EmptyState, ErrorState, LoadingSkeleton } from '@enp/ui';
import { Link, useRouter, type ErrorComponentProps } from '@tanstack/react-router';
import { MapPinOff } from 'lucide-react';
import { useEffect } from 'react';

export function RoutePending() {
  return (
    <div className="p-6 lg:p-8">
      <LoadingSkeleton variant="page" label="Loading" />
    </div>
  );
}

export function RouteError({ error, reset }: ErrorComponentProps) {
  const router = useRouter();
  // The technical detail goes to the log for support, never onto the station screen.
  useEffect(() => {
    console.error('Station screen failed to load', error);
  }, [error]);
  return (
    <div className="mx-auto max-w-2xl p-6 lg:p-8">
      <ErrorState
        title="This screen didn’t load"
        message="Something unexpected went wrong. Nothing saved on this station was lost. Try again; if it keeps happening, tell your manager what you were doing."
        actions={
          <>
            <Button
              size="lg"
              onClick={() => {
                reset();
                void router.invalidate();
              }}
            >
              Try again
            </Button>
            <Button size="lg" variant="secondary" asChild>
              <Link to="/labels">Go to Labels</Link>
            </Button>
          </>
        }
      />
    </div>
  );
}

export function NotFound() {
  return (
    <div className="mx-auto max-w-2xl p-6 lg:p-8">
      <EmptyState
        icon={MapPinOff}
        title="Screen not found"
        description="That address doesn’t match a station screen."
        action={
          <Button size="lg" asChild>
            <Link to="/">Back to the station</Link>
          </Button>
        }
      />
    </div>
  );
}
